/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './cerf-comments.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../cerf-comment/cerf-comment.component.ngfactory';
import * as i3 from '../../../../../../app/modules/cerf/components/cerf-comment/cerf-comment.component';
import * as i4 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/material';
import * as i6 from '@angular/cdk/platform';
import * as i7 from '@angular/common';
import * as i8 from '../../../../../../app/modules/cerf/components/cerf-comments/cerf-comments.component';
import * as i9 from '@angular/forms';
const styles_CerfCommentsComponent:any[] = [i0.styles];
export const RenderType_CerfCommentsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CerfCommentsComponent,data:{}});
function View_CerfCommentsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-comment',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_CerfCommentComponent_0,
      i2.RenderType_CerfCommentComponent)),i1.ɵdid(1,114688,(null as any),0,i3.CerfCommentComponent,
      ([] as any[]),{comment:[0,'comment']},(null as any))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
function View_CerfCommentsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'md-spinner',
      [['class','mat-spinner mat-progress-spinner'],['mode','indeterminate'],['role',
          'progressbar'],['style','width: 30px']],(null as any),(null as any),(null as any),
      i4.View_MdSpinner_0,i4.RenderType_MdSpinner)),i1.ɵdid(1,16384,(null as any),
      0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,180224,(null as any),0,i5.MdSpinner,[i1.ElementRef,
      i1.NgZone,i1.Renderer2],{mode:[0,'mode']},(null as any))],(_ck,_v) => {
    const currVal_0:any = 'indeterminate';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_CerfCommentsComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'mat-raised-button'],['color','primary'],['md-raised-button',''],['type','button']],
      [[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.addComment()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i4.View_MdButton_0,i4.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),
      0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,180224,(null as any),0,i5.MdButton,[i1.Renderer2,i1.ElementRef,
      i6.Platform,i5.FocusOriginMonitor],{disabled:[0,'disabled'],color:[1,'color']},
      (null as any)),i1.ɵdid(3,16384,(null as any),0,i5.MdRaisedButtonCssMatStyler,
      ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,0,['\n      Add Comment\n    ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:boolean = !_co.canComment;
        const currVal_2:any = 'primary';
        _ck(_v,2,0,currVal_1,currVal_2);
      },(_ck,_v) => {
        const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
        _ck(_v,0,0,currVal_0);
      });
}
export function View_CerfCommentsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),37,'div',[['style',
      'max-width: 600px; margin-top: 2rem']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['Comments'])),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CerfCommentsComponent_1)),i1.ɵdid(6,
      802816,(null as any),0,i7.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵeld(8,0,(null as any),(null as any),28,'div',[['class','comment-box']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(10,0,(null as any),
          (null as any),19,'md-form-field',[['class','message mat-input-container mat-form-field']],
          [[2,'mat-input-invalid',(null as any)],[2,'mat-form-field-invalid',(null as any)],
              [2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],[2,
                  'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,12)._control.focus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i4.View_MdFormField_0,i4.RenderType_MdFormField)),i1.ɵdid(11,16384,(null as any),
          0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(12,7389184,(null as any),6,i5.MdFormField,
          [i1.ElementRef,i1.ChangeDetectorRef,[2,i5.MD_PLACEHOLDER_GLOBAL_OPTIONS]],
          (null as any),(null as any)),i1.ɵqud(335544320,1,{_control:0}),i1.ɵqud(335544320,
          2,{_placeholderChild:0}),i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,
          4,{_hintChildren:1}),i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,
          6,{_suffixChildren:1}),(_l()(),i1.ɵted(-1,1,['\n      '])),(_l()(),i1.ɵeld(20,
          0,(null as any),1,8,'textarea',[['class','mat-input-element'],['mdInput',
              ''],['placeholder','Type a comment']],[[8,'id',0],[8,'placeholder',0],
              [8,'disabled',0],[8,'required',0],[1,'aria-describedby',0],[1,'aria-invalid',
                  0],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
              [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
                  (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i8.CerfCommentsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,22)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,22).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,22)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,22)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,26)._focusChanged(false)) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,26)._focusChanged(true)) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,26)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.currentCommentText = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(21,16384,(null as any),0,i5.MdPrefixRejector,
          [[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(22,16384,(null as any),0,i9.DefaultValueAccessor,[i1.Renderer2,i1.ElementRef,
          [2,i9.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),i1.ɵprd(1024,
          (null as any),i9.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i9.DefaultValueAccessor]),i1.ɵdid(24,671744,(null as any),0,i9.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i9.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),
          i9.NgControl,(null as any),[i9.NgModel]),i1.ɵdid(26,933888,(null as any),
          0,i5.MdInput,[i1.ElementRef,i1.Renderer2,i6.Platform,[2,i9.NgControl],[2,
              i9.NgForm],[2,i9.FormGroupDirective],[2,i5.MD_ERROR_GLOBAL_OPTIONS]],
          {placeholder:[0,'placeholder']},(null as any)),i1.ɵdid(27,16384,(null as any),
          0,i9.NgControlStatus,[i9.NgControl],(null as any),(null as any)),i1.ɵprd(2048,
          [[1,4]],i5.MdFormFieldControl,(null as any),[i5.MdInput]),(_l()(),i1.ɵted(-1,
          1,['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CerfCommentsComponent_2)),
      i1.ɵdid(32,16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CerfCommentsComponent_3)),
      i1.ɵdid(35,16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n']))],
      (_ck,_v) => {
        var _co:i8.CerfCommentsComponent = _v.component;
        const currVal_0:any = _co.comments;
        _ck(_v,6,0,currVal_0);
        const currVal_24:any = _co.currentCommentText;
        _ck(_v,24,0,currVal_24);
        const currVal_25:any = 'Type a comment';
        _ck(_v,26,0,currVal_25);
        const currVal_26:any = _co.loading;
        _ck(_v,32,0,currVal_26);
        const currVal_27:boolean = !_co.loading;
        _ck(_v,35,0,currVal_27);
      },(_ck,_v) => {
        const currVal_1:any = i1.ɵnov(_v,12)._control.errorState;
        const currVal_2:any = i1.ɵnov(_v,12)._control.errorState;
        const currVal_3:any = i1.ɵnov(_v,12)._control.focused;
        const currVal_4:any = i1.ɵnov(_v,12)._shouldForward('untouched');
        const currVal_5:any = i1.ɵnov(_v,12)._shouldForward('touched');
        const currVal_6:any = i1.ɵnov(_v,12)._shouldForward('pristine');
        const currVal_7:any = i1.ɵnov(_v,12)._shouldForward('dirty');
        const currVal_8:any = i1.ɵnov(_v,12)._shouldForward('valid');
        const currVal_9:any = i1.ɵnov(_v,12)._shouldForward('invalid');
        const currVal_10:any = i1.ɵnov(_v,12)._shouldForward('pending');
        _ck(_v,10,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,
            currVal_8,currVal_9,currVal_10);
        const currVal_11:any = i1.ɵnov(_v,26).id;
        const currVal_12:any = i1.ɵnov(_v,26).placeholder;
        const currVal_13:any = i1.ɵnov(_v,26).disabled;
        const currVal_14:any = i1.ɵnov(_v,26).required;
        const currVal_15:any = (i1.ɵnov(_v,26)._ariaDescribedby || (null as any));
        const currVal_16:any = i1.ɵnov(_v,26).errorState;
        const currVal_17:any = i1.ɵnov(_v,27).ngClassUntouched;
        const currVal_18:any = i1.ɵnov(_v,27).ngClassTouched;
        const currVal_19:any = i1.ɵnov(_v,27).ngClassPristine;
        const currVal_20:any = i1.ɵnov(_v,27).ngClassDirty;
        const currVal_21:any = i1.ɵnov(_v,27).ngClassValid;
        const currVal_22:any = i1.ɵnov(_v,27).ngClassInvalid;
        const currVal_23:any = i1.ɵnov(_v,27).ngClassPending;
        _ck(_v,20,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
            currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23]);
      });
}
export function View_CerfCommentsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-cerf-comments',
      ([] as any[]),(null as any),(null as any),(null as any),View_CerfCommentsComponent_0,
      RenderType_CerfCommentsComponent)),i1.ɵdid(1,114688,(null as any),0,i8.CerfCommentsComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CerfCommentsComponentNgFactory:i1.ComponentFactory<i8.CerfCommentsComponent> = i1.ɵccf('app-cerf-comments',
    i8.CerfCommentsComponent,View_CerfCommentsComponent_Host_0,{saveComment:'saveComment',
        comments:'comments'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/cerf/components/cerf-comments/cerf-comments.component.ngfactory.ts